<div class="equities-balance-card mt-3">
  <!-- Top Bar: Back Button -->
  <div class="card-top-bar">
    <button class="btn-back-top" (click)="goBack()">
      <i class="fas fa-arrow-left"></i>
      <span>{{ translate?.currentLang === 'en' ? 'Back' : 'পিছনে' }}</span>
    </button>
                        </div>
  <div class="balance-card-header">
    <h4>Equities Accounts</h4>
                      </div>

  <div class="balance-content">
    <div class="loader" [hidden]="!balanceInProgress">
      <div class="spinner"></div>
                  </div>

    <div class="balance-list" [hidden]="balanceInProgress">
      <div class="balance-item" *ngFor="let item of calsBalancesDetails; let i = index"
        routerLink="/dashboard/equity/summary/{{ item?.investorCode }}/portfolio/">
        <div class="account-info">
          <div class="account-name">
            <span class="name">{{ item?.investorName }}</span>
            <span class="code">[{{ item?.investorCode }}]</span>
                </div>
          <div class="account-type-icons">
            <i class="ind fas fa-user-tie" *ngIf="i === 0"></i>
            <i class="far joint fa-handshake" *ngIf="i !== 0"></i>
          </div>
        </div>
        <div class="account-balance">
          <span class="currency">BDT</span>
          <span class="amount">{{ item?.balance | number : 2 }}</span>
        </div>
      </div>

      <div class="no-balance" *ngIf="!calsBalancesDetails || calsBalancesDetails.length === 0">
        <p>No accounts found</p>
      </div>
    </div>
  </div>
</div>